// extracted by mini-css-extract-plugin
export var body = "_li-0";
export var sectionHeader = "_li-4";
export var shortcutColumns = "_li-2";
export var shortcutList = "_li-1";
export var shortcutSection = "_li-3";